import { render, staticRenderFns } from "./SurveyManagement.vue?vue&type=template&id=60e3a398&scoped=true&"
import script from "./SurveyManagement.vue?vue&type=script&lang=js&"
export * from "./SurveyManagement.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagement.vue?vue&type=style&index=0&id=60e3a398&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e3a398",
  null
  
)

export default component.exports